import { useState } from "react";
import { Calendar, ArrowUpRight } from "lucide-react";
import Layout, { PageHero } from "@/components/Layout";
import LeadForm from "@/components/LeadForm";
import { Reveal, Overline } from "@/components/Reveal";
import { useSettings } from "@/context/SettingsContext";
import { MEDIA } from "@/lib/content";

const CALL_TYPES = [
  { key: "strategy_call", label: "Strategy Call" },
  { key: "cre_consultation", label: "CRE Consultation" },
  { key: "capital_strategy_call", label: "Capital Strategy Call" },
  { key: "media_audit", label: "Media Audit" },
  { key: "coaching_call", label: "Coaching Call" },
];

export default function BookCall() {
  const { settings } = useSettings();
  const [active, setActive] = useState("strategy_call");
  const calendarUrl = settings.calendar?.[active] || settings.redirects?.book_call;

  return (
    <Layout>
      <PageHero
        overline="Book a Call"
        title="Let's Talk Strategy."
        subtitle="Pick the conversation that fits where you are. We'll review what you control and map the next move."
        image={MEDIA.heroSkyline}
      />

      <section className="py-16 max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-14">
        <Reveal>
          <Overline>Select a Call</Overline>
          <div className="mt-6 space-y-3">
            {CALL_TYPES.map((c) => (
              <button
                key={c.key}
                onClick={() => setActive(c.key)}
                className={`w-full text-left p-5 border transition-colors flex items-center justify-between ${
                  active === c.key ? "border-[#CC5500] bg-[#1A1A1A]" : "border-white/10 bg-[#141414] hover:border-white/30"
                }`}
                data-testid={`call-type-${c.key}`}
              >
                <span className="font-display font-semibold">{c.label}</span>
                <Calendar size={18} className={active === c.key ? "text-[#CC5500]" : "text-neutral-600"} />
              </button>
            ))}
          </div>
          {calendarUrl && (
            <a href={calendarUrl} target="_blank" rel="noopener noreferrer" className="btn-primary mt-8" data-testid="open-calendar-btn">
              Open Calendar <ArrowUpRight size={16} />
            </a>
          )}
        </Reveal>

        <Reveal delay={0.1}>
          {calendarUrl?.includes("calendly.com") ? (
            <div className="border border-white/10 overflow-hidden bg-white" style={{ minHeight: 640 }}>
              <iframe
                title="Booking calendar"
                src={calendarUrl}
                className="w-full"
                style={{ minHeight: 640, border: "none" }}
                data-testid="calendar-iframe"
              />
            </div>
          ) : (
            <div className="card-edge p-8">
              <LeadForm formKey="strategy_call" sourcePage="/book-call" />
            </div>
          )}
        </Reveal>
      </section>

      <section className="pb-20 max-w-3xl mx-auto px-6">
        <div className="card-edge p-8">
          <p className="overline text-neutral-400 mb-6">Prefer we reach out? Leave your details.</p>
          <LeadForm formKey="strategy_call" sourcePage="/book-call" />
        </div>
      </section>
    </Layout>
  );
}
